var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPropertyProcurement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 14.4165L34.5 8.1665L22 1.9165V22.7498",
    stroke: "#34906E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6668 22.729L2.20849 29.2707C1.88787 29.4524 1.62118 29.7159 1.43564 30.0343C1.2501 30.3527 1.15234 30.7146 1.15234 31.0832C1.15234 31.4517 1.2501 31.8136 1.43564 32.132C1.62118 32.4505 1.88787 32.714 2.20849 32.8957L19.9168 43.0207C20.5502 43.3864 21.2687 43.5789 22.0002 43.5789C22.7316 43.5789 23.4501 43.3864 24.0835 43.0207L41.7918 32.8957C42.1124 32.714 42.3791 32.4505 42.5647 32.132C42.7502 31.8136 42.848 31.4517 42.848 31.0832C42.848 30.7146 42.7502 30.3527 42.5647 30.0343C42.3791 29.7159 42.1124 29.4524 41.7918 29.2707L30.3335 22.7498M10.521 24.5207L33.4793 37.6457M33.4793 24.5207L10.5418 37.6457",
    stroke: "#34906E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyProcurement);
export default __webpack_public_path__ + "static/media/PropertyProcurement.67e34decb9aeb064dbe4ae33da108a76.svg";
export { ForwardRef as ReactComponent };